import { VerifiedGuard } from '../core/authorization/verified-user.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataExportsComponent } from './data-exports.component';

const routes: Routes = [
  {
    path: 'response-list',
    component: DataExportsComponent,
    canActivate: [VerifiedGuard],
    data: { title: 'Export Response list', type: 'response-list' },
  },
  {
    path: 'widgets',
    component: DataExportsComponent,
    canActivate: [VerifiedGuard],
    data: { title: 'Export widgets', type: 'widgets' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DataExportsRoutingModule {}
